import React from "react";
import { ReadOnlyShipmentNotes, ShipmentNotes } from "components/shipment-editor/notes/components";

export const Notes = () => {
    return (
        <>
            <ReadOnlyShipmentNotes />
            <ShipmentNotes />
        </>
    );
};
